import { useCallback, useMemo } from 'react'

import {
  getApiUrl,
  settingsPath,
  signupPath,
} from '$extensionSrc/consts/urlConsts'
import { openNewPrivacyPartyServerTab } from '$extensionSrc/utils/tabs'

import { User } from './user'

type UseUpgradeRv = {
  onClick: () => void
  url: string | undefined
}

export function useUpgrade(user: User): UseUpgradeRv {
  const path = useMemo(() => {
    if (user === undefined) {
      return undefined
    }
    return user === null ? signupPath : settingsPath
  }, [user])

  const onClick = useCallback(() => {
    if (path !== undefined) {
      openNewPrivacyPartyServerTab(path, {})
    }
  }, [path])

  const url = useMemo(() => {
    if (path) {
      return getApiUrl(path, null)
    }
    return undefined
  }, [path])

  return {
    onClick,
    url,
  }
}
